// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/BloqueiosAgenda_UpdateResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /bloqueios_agenda/update
 *
 * Returns the updated schedule bloqueio record.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface BloqueiosAgenda_UpdateResponseDados {
bloqueio_agenda_data_hora_inicio: string
bloqueio_agenda_data_hora_fim: string
bloqueio_agenda_id?: number
bloqueio_agenda_titulo?: string
bloqueio_agenda_operador_user_id?: string
bloqueio_agenda_criador_user_id?: string
bloqueio_agenda_data_cadastro?: string
}

export type BloqueiosAgenda_UpdateResponse = ApiResponse<BloqueiosAgenda_UpdateResponseDados>;

registerResponseContract('BloqueiosAgenda_UpdateResponse', {
  bloqueio_agenda_data_hora_inicio: { type: 'string',  required: true },
  bloqueio_agenda_data_hora_fim:    { type: 'string',  required: true },
  bloqueio_agenda_id:               { type: 'number',  required: false },
  bloqueio_agenda_titulo:           { type: 'string',  required: false },
  bloqueio_agenda_operador_user_id: { type: 'string',  required: false },
  bloqueio_agenda_criador_user_id:  { type: 'string',  required: false },
  bloqueio_agenda_data_cadastro:    { type: 'string',  required: false },
})
